import { useRouteMatch } from "react-router";
import { personalDashboardPaths } from "src/routes/routesDef";

export function usePersonalDashboardActivityPageRouteMatch(): { isDashboardActivityPage: boolean } {
  const isDashboardActivityPage = !!useRouteMatch([personalDashboardPaths.activity]);
  return { isDashboardActivityPage };
}
